import { createAction } from '@reduxjs/toolkit';
import type {
  Chart, ChartId,
} from './mapSettingsCharts.types';

export const mapSettingsChartsRemoveCharts = createAction(
  'MAP_SETTINGS_CHARTS_REMOVE_CHARTS',
  (ids: ReadonlySet<ChartId>) => ({
    payload: { ids },
  })
);

export const mapSettingsChartsAddOrUpdateChart = createAction(
  'MAP_SETTINGS_CHARTS_ADD_OR_UPDATE_CHART',
  (chart: Chart) => ({
    payload: { chart },
  })
);
